import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class RecurringTemplates extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "RecurringTemplates";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      name: null,
      description: null,
      mid_id: null,
      payment_type: "AUTOPAY",

      schedule: {
        interval: null,
        periods: 1,
        cycles: 1,
        retries: 3,
        late_days: 5,
        overdue_days: 10,
        reminder_days: 1,
      },

      cart: null,
      email: {},

      meta_data: {},
      custom_fields: [],
      tags: [],
      notes: [],

      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {
    if (data.mid) {
      data.mid = new models.api.Mids(data.mid);
    }
    if (data.cart) {
      data.cart = new models.api.Carts(data.cart);
    }


    // if (data.subscriptions && data.subscriptions.length > 0) {
    //   data.subscriptions.map(async (subscriptions) => {
    //     subscriptions = new models.api.Subscriptions(subscriptions);
    //   });
    // }

    return data;
  }
}
